import { Outlet } from 'react-router-dom'
function JobFairIndex() {
    return (
        <div className="mx-0">
            <Outlet />
        </div>
    )
}
export default JobFairIndex
